export function colorPerType(zoneType: number) {
  const znStandard = 0x00a86b;
  const znOpenSpace = 0xd8eb34;
  const znConference = 0x1798ff; // 0x2b60ab;
  const znRestricted = 0xeb5334;

  switch (zoneType) {
    case 1:
      return znStandard; // STANDARD office
    case 2:
      return znOpenSpace; // OPENSPACE
    case 3:
      return znConference; // CONFERENCE
    case 4:
      return znRestricted; // RESTRICTED
    default:
      return znStandard;
  }
}
